var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-gallery"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,attrs:{"span":8}},[_c('div',{staticClass:"left"},[_c('GalleryPhoto',{attrs:{"imgURL":item.imgURL,"caption":item.caption}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }